var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.68609 34.6076H0V39.0005H4.72522V38.3274H0.68609V34.6076ZM31.4689 34.6076V38.3274H27.4298V39.0005H32.155V34.6076H31.4689ZM0.000308037 15.4174H0.686398V11.6984H4.72553V11.0254H0.000308037V15.4174ZM27.4298 11.0254V11.6984H31.4689V15.4174H32.155V11.0254H27.4298Z",
    fill: "#C8ECDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9314 33.9489H26.3183C26.0146 31.7369 25.6421 29.2118 25.6421 29.2118C25.6421 29.2118 25.4555 31.2957 25.2285 33.9489H6.77081C6.60243 31.5628 6.39969 29.7778 6.32627 29.7413C6.22053 29.688 5.5618 31.805 5.01556 33.9489H0.0185547C1.30367 28.4042 3.70081 19.5083 5.08696 18.9754C7.05909 18.2155 15.1039 15.7324 15.1039 15.7324H19.6947C19.6947 15.7324 27.852 18.0635 28.6111 20.5979C29.2146 22.6177 30.5455 29.2779 30.9314 33.9489Z",
    fill: "#91D8BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8455 0.868295C17.8455 0.868295 22.1327 1.54051 21.4799 8.21683C20.8272 14.8932 17.0432 14.3459 16.7906 14.3391C16.5373 14.3324 12.9918 14.4609 12.7156 6.30953C12.7156 6.30953 12.5943 0.281898 17.8455 0.868295Z",
    fill: "#EEA987"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4547 12.6053C19.4547 12.6053 19.3384 15.4015 19.6024 16.0069C19.8657 16.6122 16.1101 18.5565 13.8193 16.3897C13.8193 16.3897 14.3726 13.3509 14.219 12.2738C14.0647 11.1967 19.4547 12.6053 19.4547 12.6053Z",
    fill: "#EEA987"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4971 6.5746C21.4971 6.5746 21.9232 6.05977 22.0791 6.58096C22.2356 7.10215 21.4183 9.431 21.4721 9.5355C21.4721 9.5355 21.3938 9.73759 21.2918 9.62631C21.1897 9.51503 21.4971 6.5746 21.4971 6.5746Z",
    fill: "#EEA987"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5264 6.30638C12.5264 6.30638 12.0856 5.78393 11.9111 6.29997C11.7366 6.81607 12.5581 9.1549 12.4999 9.2579C12.4999 9.2579 12.5787 9.46108 12.6886 9.35236C12.7985 9.2437 12.5264 6.30638 12.5264 6.30638Z",
    fill: "#EEA987"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5202 7.61455L20.9043 8.44543C20.9043 8.44543 20.9212 6.62385 20.8225 6.33825C20.7238 6.05265 20.5724 5.1801 20.4899 4.97431C20.4075 4.76858 16.7956 3.74726 13.6049 5.27253C13.6049 5.27253 13.7455 6.58238 13.44 6.69895C13.1338 6.81553 13.2838 8.83225 13.2838 8.83225L12.7775 8.25566C12.7775 8.25566 12.0021 3.03009 12.1934 2.48543C12.3854 1.94076 12.9952 -1.33377 19.5402 0.610106C19.5402 0.610106 21.581 0.173966 21.9907 1.59555C22.4003 3.01706 21.5202 7.61455 21.5202 7.61455Z",
    fill: "#D98B52"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7935 15.7533C19.7935 15.7533 20.734 15.9614 16.7987 19.8725C16.7987 19.8725 14.0075 16.6705 14.0979 16.1342C14.1882 15.598 19.7935 15.7533 19.7935 15.7533Z",
    fill: "#EEA987"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.855 19.8955L17.9685 21.8048L21.2711 16.1811L19.8405 15.1807L16.855 19.8955Z",
    fill: "#24B275"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8554 19.9408L14.2131 15.7324L12.7153 16.696L15.4008 21.8046L16.8554 19.9408Z",
    fill: "#24B275"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9404 31.6847C15.9739 32.3129 15.9889 33.0836 15.991 33.9485H15.8366C15.8352 33.087 15.8202 32.3183 15.7867 31.6921C15.5347 26.9678 16.6972 21.2193 16.7047 19.8721L16.855 19.9013C16.8475 21.2485 15.6884 26.9807 15.9404 31.6847Z",
    fill: "#24B275"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9233 13.69C14.9233 13.69 15.9772 14.8314 17.466 14.5269C18.9547 14.2225 19.6155 13.5244 19.6155 13.5244C19.6155 13.5244 19.0279 15.034 17.307 15.1721C15.5855 15.3102 14.9233 13.69 14.9233 13.69Z",
    fill: "#C78D71"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 34.5,
    r: 6.5,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 28C26.9093 28 24 30.9093 24 34.5C24 38.0907 26.9093 41 30.5 41C34.0907 41 37 38.0907 37 34.5C37 30.9093 34.0907 28 30.5 28ZM34.2742 35.2339C34.2742 35.4069 34.1327 35.5484 33.9597 35.5484H31.5484V37.9597C31.5484 38.1327 31.4069 38.2742 31.2339 38.2742H29.7661C29.5931 38.2742 29.4516 38.1327 29.4516 37.9597V35.5484H27.0403C26.8673 35.5484 26.7258 35.4069 26.7258 35.2339V33.7661C26.7258 33.5931 26.8673 33.4516 27.0403 33.4516H29.4516V31.0403C29.4516 30.8673 29.5931 30.7258 29.7661 30.7258H31.2339C31.4069 30.7258 31.5484 30.8673 31.5484 31.0403V33.4516H33.9597C34.1327 33.4516 34.2742 33.5931 34.2742 33.7661V35.2339Z",
    fill: "#24B275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.e5108d15598e30a5af9f747c81c8ec5d.svg";
export { ForwardRef as ReactComponent };